import { Grid as MuiGrid } from '@mui/material';
import type { JSX } from 'react';

interface Props {
  children: JSX.Element[];
  columnWidth?: string;
  maxColumns?: number;
  overflow?: 'auto' | 'hidden';
  spacing?: string;
}

export function GridLayout({
  children,
  columnWidth = '100%',
  maxColumns = 12,
  overflow = 'auto',
  spacing = '0.4rem',
}: Props) {
  const size = 12 / maxColumns;

  return (
    <MuiGrid container overflow={overflow} spacing={spacing}>
      {children.map((child, index) => (
        <MuiGrid size={size} minWidth={columnWidth} key={index}>
          {child}
        </MuiGrid>
      ))}
    </MuiGrid>
  );
}
